import React from 'react';

import { getCloudId, getHelpCenterAri } from '@helpcenter/meta';
import { useRouter } from 'react-resource-router';

import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import { RovoServiceAgentWidgetInjector } from '@atlassian/rovo-service-agent-chat-widget';

import { PortalRovoWidget } from './portal-rovo-widget';

// Route names to exclude from showing the Rovo widget. These are the customisable hub pages, where
// the callout banner is already the Rovo entry point, so this corner widget would be a second one.
const EXCLUDED_ROVO_WIDGET_ROUTES = ['hub', 'hub-custom-page', 'hub-portal-page'];

/**
 * Wrapper component that renders the Rovo widget only on specific routes.
 * Excludes the homepage, custom page and portal page routes.
 *
 * The Rovo widget SDK resolves the agent from the container it is given, so a portal-scoped route
 * (request create, portal articles, portal login/signup, unsubscribe, feedback) must pass its
 * portal's container rather than the help center's — otherwise it opens the hub's agent.
 */
export const RovoWidgetRenderer = () => {
	const [routerState] = useRouter();
	const currentRouteName = routerState.route?.name;

	if (!currentRouteName || EXCLUDED_ROVO_WIDGET_ROUTES.includes(currentRouteName)) {
		return null;
	}

	const cloudId = getCloudId();
	const helpCenterAri = getHelpCenterAri();

	if (!cloudId || !helpCenterAri) {
		return null;
	}

	// Keyed off the route carrying a portalId rather than a list of route names, so new
	// portal-scoped routes are covered without anyone having to remember to add them here.
	const portalId = routerState.match?.params?.portalId;

	if (portalId && FeatureGates.checkGate('hubs_rovo_config_from_kosh')) {
		return <PortalRovoWidget portalId={portalId} cloudId={cloudId} />;
	}

	return <RovoServiceAgentWidgetInjector siteId={cloudId} widgetId={helpCenterAri} surface="HUB" />;
};
